import { Component, Inject, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { EbAuthStatePersistenceService } from '../../../auth/services/eb-auth-state-persistence.service'
import { EbAuthService } from '../../../auth/services/eb-auth.service'
import { EbUserIdService } from '../../../auth/services/eb-user-id.service'
import { EbUserAccountService } from '../../services/eb-user-account.service'

@Component({
    selector: 'eb-login',
    templateUrl: './eb-login.component.html',
    styleUrls: ['./eb-login.component.scss'],
    standalone: false
})
export class EbLoginComponent implements OnDestroy {
  isLoggedIn$: Observable<boolean> = this.authService.isUserLoggedIn()
  private readonly mode$ = new BehaviorSubject<string>(null)
  private readonly subscriptions = new Subscription()

  constructor(
    public userAccountService: EbUserAccountService,
    protected authService: EbAuthService,
    protected router: Router,
    protected userIdService: EbUserIdService,
    @Inject(EbAuthStatePersistenceService)
    protected ebAuthStatePersistenceService: EbAuthStatePersistenceService
  ) {}

  loginWithSapIDP() {
    this.authService.loginWithSapIDP()
  }

  reportRenderMode(mode: string) {
    this.mode$.next(mode)
    return mode
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }
}
